<template>
  <v-bottom-sheet
    hide-overlay
    v-model="sheet"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
      
        id="document_add__nuevo_documento__button"
        color="green"
        dark
        outlined
        v-bind="attrs"
        v-on="on"
      >
      <v-icon small left>{{ icon.plus }}</v-icon>
        Nuevo Documento
      </v-btn>
    </template>
    <v-sheet
      class="text-center"
      height="300px"
    >
      <div class="mt-n12 h100">
        <drag-files id="dragfiles"></drag-files>
        <upload-wizard attach="#dragfiles" />
      </div>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mdiPlus } from '@mdi/js'
import DragFiles from '../components/DragFiles'
import UploadWizard from '@/modules/documents/pages/UploadWizard'

import {
  uploadWizardData
} from '@/modules/documents/store/uploadWizardStoreHelpers'

export default {
  name: 'DocumentAdd',
  components: {
    UploadWizard,
    DragFiles,
  },
  data() {
    return {
      icon: {
        plus: mdiPlus
      },
      sheet: false
    }
  },
  computed: {
    ...uploadWizardData
  },
  watch: {
    dialogUploadWizard: function(value) {
      if(value) {
        this.sheet = false
      }
    }
  }
}
</script>

<style scoped>
  .btn-close {
    z-index: 1;
    margin: 6px;
  }
  .h100 {
    height: inherit;
  }
</style>
